import { Video, Mic, MessagesSquare, UserRound, ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const PILLARS = [
  { icon: Video, label: "Real-Time Video", path: "/technology/real-time-ai-video" },
  { icon: Mic, label: "Voice", path: "/technology/ai-voice" },
  { icon: MessagesSquare, label: "Conversational AI", path: "/technology/conversational-ai" },
  { icon: UserRound, label: "Photorealistic Characters", path: "/technology/photorealistic-ai-characters" },
];

export default function WhyDifferent() {
  return (
    <section data-testid="why-different-section" className="relative py-16 lg:py-36">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-2 lg:px-10">
        <div>
          <Reveal>
            <SectionTag>Why Different</SectionTag>
            <h2 className="font-display mt-5 text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
              Beyond <span className="text-cyan-300">Text-Based AI</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-[#C5CBD5]">
              Many AI companion experiences today are primarily text or image based. Our vision is a
              more immersive experience — one where the character is present on screen, speaks,
              reacts and creates a stronger sense of real-time presence.
            </p>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-[#C5CBD5]">
              We combine four layers into a single experience.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="font-display mt-10 text-sm uppercase tracking-[0.3em] text-white/50">
              <span className="line-through decoration-white/30">Text</span>
              <span className="mx-3 text-cyan-300">→</span>
              <span className="text-white/70">Video + Voice + Emotion</span>
            </p>
          </Reveal>
        </div>

        <div className="grid gap-3">
          {PILLARS.map(({ icon: Icon, label, path }, i) => (
            <Reveal key={label} delay={0.08 * i}>
              <a
                href={path}
                data-testid={`pillar-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group flex items-center gap-5 rounded-xl border border-cyan-300/15 bg-white/[0.03] px-6 py-5 transition-colors duration-500 hover:border-cyan-300/40"
              >
                <span className="font-display text-xs font-light text-white/25">0{i + 1}</span>
                <Icon size={18} className="text-cyan-300/80 transition-transform duration-500 group-hover:-translate-y-0.5" />
                <span className="font-display text-base font-medium tracking-tight text-white/85">{label}</span>
                <span className="ml-auto inline-flex shrink-0 items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-cyan-300/80 transition-colors duration-300 group-hover:text-cyan-100">
                  Learn more
                  <ArrowRight size={12} className="transition-transform duration-300 group-hover:translate-x-0.5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
